import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { CheckButton } from 'components';
import { PenaltyIcon } from 'static';

interface PenaltyButtonProps {
  checked: boolean;
  onChange: (e: Event) => void;
}

const PenaltyButton: FC<PenaltyButtonProps> = ({ checked, onChange }) => {
  const { t } = useTranslation();

  return (
    <CheckButton
      value="penalty"
      label={t('event.penalty')}
      checked={checked}
      onChange={onChange}
      icon={PenaltyIcon}
    />
  );
};

export default PenaltyButton;
